<section id="services">
    
    <div class="service-tab-section">
        <div class="row">

            <div class="col-md-3 gray-service-detail gsd-one">
                <div class="contentTexture contentTexturefirst" >
                    <!-- <div class="newiconsH web3-0-icon"></div> -->
                    <h5 style="padding-top:50px" >Our Services</h5>
                    <div class="clearfix"></div>
                    <p style="font-size: 16px;">We build the foundation for cognitive business by working with complex technologies and rapidly evolving business environment, to offer project performance optimization.

                    </p>
                </div>
            </div>
            <div class="col-md-3 gray-service-detail">
                <div class="contentTexture">
                    <div class="newiconsH mobileIcon">  </div>
                    <h5>Mobile &amp; Wearables</h5>
                    <ul class="list">
                        <li>
                            <a target="_blank" title="iOS" href="/ios-app-development.html">iOS</a>
                        </li>
                        <li>
                            <a target="_blank" title="Android" href="/android-app-development.html">Android</a>
                        </li>
                        <li>
                            <a target="_blank" title="Flutter" href="/flutter-development.html">Flutter</a>
                        </li>
                        <li>
                          <a target="_blank" title="React Native" href="/react-native.html">React Native</a>
                      </li>
                    </ul>
                    <div class="clearfix"></div>
                    <p>We offer an affordable mobile app development service for both android and iOS as well as
                        hybrid app development for different types of businesses.</p>
                </div>
            </div>
            <div class="col-md-3 gray-service-detail">
                <div class="contentTexture">
                    <div class="newiconsH ecommerce-icon"></div>
                    <h5>Ecommerce Development</h5>
                    <ul class="list">
                        <li>
                            <a target="_blank" title="Magento" href="/magento-development.html">MAGENTO</a>
                        </li>
                        <li>
                            <a target="_blank" title="Shopify" href="/shopify-development.html">Shopify</a>
                        </li>
                        <li>
                          <a target="_blank" title="Shopware" href="/shopware-development.html">Shopware</a>
                      </li>
                      <li>
                        <a target="_blank" title="WooCommerce" href="/hire-woocommerce-developers.html">WooCommerce</a>
                      </li>
                    </ul>
                    <div class="clearfix"></div>
                    <p>We can help you to create a user-friendly website so you can reach out to your potential
                        customers online and maximize the sales of your business.</p>
                </div>
            </div>
            <div class="col-md-3 gray-service-detail">
                <div class="contentTexture">
                    <div class="newiconsH web-icon"></div>
                    <h5>Web Development</h5>
                    <ul class="list">
                        <li>
                            <a target="_blank" href="/hire-php-developers.html">PHP</a>
                        </li>
                        <li>
                            <a target="_blank" href="/hire-dotnet-developers.html">
                                <strong>.</strong>Net
                            </a>
                        </li>
                        <li>
                            <a target="_blank" href="/hire-java-developers.html">Java</a>
                        </li>
                        <li>
                            <a target="_blank" href="/hire-python-developers.html">Python</a>
                        </li>
                    </ul>
                    <div class="clearfix"></div>
                    <p>We provide high-end and user-friendly web development services that help to create your ideas
                        into reality in front of a wide range of audiences.</p>
                </div>
            </div>
            <div class="col-md-3 gray-service-detail">
                <div class="contentTexture">
                    <div class="newiconsH javascript-icon"></div>
                    <h5>Javascript</h5>
                    <ul class="list">
                        <li>
                            <a target="_blank" href="/hire-angular-js-developers.html">Angular </a>
                        </li>
                        <li>
                            <a target="_blank" href="/hire-vue-js-developers.html">Vue</a>
                        </li>
                        <li>
                            <a target="_blank" href="/hire-react-js-developers.html">React</a>
                        </li>
                        <li>
                          <a target="_blank" href="/hire-node-js-developers.html">Node</a>
                        </li>
                    </ul>
                    <div class="clearfix"></div>
                    <p>We have an excellent team of professionals for Javascript development that can help to build
                        cross-platform applications to succeed in your business.</p>
                </div>
            </div>
            <div class="col-md-3 gray-service-detail">
                <div class="contentTexture">
                    <div class="newiconsH game-icon"></div>
                    <h5>Game</h5>
                    <ul class="list">
                        <li>
                            <a target="_blank" href="/getaquote.html">OCULUS RIFT </a>
                        </li>
                        <li>
                            <a target="_blank" href="/augumented-reality.html">AR </a>
                        </li>
                        <li>
                            <a target="_blank" href="/getaquote.html">HTC VIVE</a>
                        </li>
                    </ul>
                    <div class="clearfix"></div>
                    <p>We develop all kinds of games, with our latest technologies &amp; highly skilled developers
                        we tend to provide the best mobile game development services.</p>
                </div>
            </div>
            <div class="col-md-3 gray-service-detail">
                <div class="contentTexture">
                    <div class="newiconsH offshore-icon"></div>
                    <h5>Offshore Staffing</h5>
                    <ul class="list">
                        <li>
                          <a target="_blank" href="/front-end-development.html">Front End</a>
                        </li>
                        <li>
                            <a target="_blank" href="/ecommerce-development.html">Ecommerce</a>
                        </li>
                        <li>
                            <a target="_blank" href="/cms-development.html">CMS</a>
                        </li>
                        <li>
                            <a target="_blank" href="/web-application-development.html">Web App</a>
                        </li>
                    </ul>
                    <div class="clearfix"></div>
                    <p>Our offshore staffing services help you to find a trusted and best workforce for your
                        business.</p>
                </div>
            </div>
            <div class="col-md-3 gray-service-detail">
              <div class="contentTexture">
                <div class="newiconsH web3-0-icon"></div>
                <h5>CRM & ERP Services</h5>
                <ul class="list">
                    <li>
                        <a target="_blank" href="/salesforce-development.html">Salesforce</a>
                    </li>
                    <li>
                        <a target="_blank" href="/oracle-development.html">Oracle</a>
                    </li>
                    <li>
                        <a target="_blank" href="/odoo-development.html">odoo</a>
                    </li>
                    <li>
                        <a target="_blank" href="/microsoft-dynamic.html">microsoft-dynamic</a>
                    </li>
                </ul>
                <div class="clearfix"></div>
                <p>Streamline your business processes with our expert Salesforce,Oracle,odoo and microsoft-dynamic CRM & ERP services.
                    </p>
              </div>
            </div>
        </div>
    </div>
</section>